import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import formBg from "../../assets/images/contactus-form-bg.jpg";
import "./contactus.css";

const faqs = [
  { q: "How do I register as a doctor on the portal?" },
  { q: "Is my data and patient information secure?" },
  { q: "Can I manage my appointments through the portal?" },
  { q: "Can I access the portal on my mobile phone?" },
  { q: "How can I collaborate with other doctors or specialists?" },
];

export const Contactus = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <>
      {/* ── Hero ── */}
      <section
        className="cu-hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Contact US</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      {/* ── Let's Talk + Form ── */}
      <section className="cu-section">
        <Container fluid className="cu-container">
          <Row className="g-5 align-items-start">
            {/* Left — contact info */}
            <Col xs={12} lg={6}>
              <h2 className="cu-talk__title">Let's Talk</h2>
              <p className="cu-talk__desc">
                Empowering hospitals, physicians, and patients with real-time
                communication and clinical collaboration—because better care
                starts with better connection.
              </p>

              <div className="cu-talk__info">
                <div className="cu-talk__info-row">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <span>+91 5252525252</span>
                </div>
                <div className="cu-talk__info-row">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <span>rjvijs42@gmail.com</span>
                </div>
                <div className="cu-talk__info-row">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span>
                    H-Block, Sector-63, Noida, Uttar Pradesh, 201301, India
                  </span>
                </div>
              </div>

              <div className="cu-talk__follow">
                <p className="cu-talk__follow-label">Follow Us</p>
                <div className="cu-talk__socials">
                  {/* LinkedIn */}
                  <a href="#" aria-label="LinkedIn" className="cu-social-icon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                      <rect x="2" y="9" width="4" height="12" />
                      <circle cx="4" cy="4" r="2" />
                    </svg>
                  </a>
                  {/* Instagram */}
                  <a href="#" aria-label="Instagram" className="cu-social-icon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                    </svg>
                  </a>
                  {/* Facebook */}
                  <a href="#" aria-label="Facebook" className="cu-social-icon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                    </svg>
                  </a>
                  {/* Twitter/X */}
                  <a href="#" aria-label="Twitter" className="cu-social-icon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                  </a>
                  {/* YouTube */}
                  <a href="#" aria-label="YouTube" className="cu-social-icon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
                      <polygon
                        points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </Col>

            {/* Right — contact form */}
            <Col xs={12} lg={6}>
              <div
                className="cu-form-card"
                style={{ backgroundImage: `url(${formBg})` }}
              >
                <div className="cu-form-card__overlay" />
                <div className="cu-form-card__inner">
                  <h3 className="cu-form__title">Get In Touch</h3>
                  <p className="cu-form__subtitle">We'd love to hear you</p>
                  <form onSubmit={(e) => e.preventDefault()}>
                    <input
                      className="cu-form__input"
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={form.name}
                      onChange={handleChange}
                    />
                    <input
                      className="cu-form__input"
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={form.email}
                      onChange={handleChange}
                    />
                    <input
                      className="cu-form__input"
                      type="tel"
                      name="phone"
                      placeholder="Phone No"
                      value={form.phone}
                      onChange={handleChange}
                    />
                    <textarea
                      className="cu-form__input cu-form__textarea"
                      name="message"
                      placeholder="Message"
                      rows={4}
                      value={form.message}
                      onChange={handleChange}
                    />
                    <div className="cu-form__btn-wrap">
                      <button type="submit" className="cu-form__btn">
                        Send Now
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── Google Map ── */}
      <section className="cu-map-section">
        <Container fluid className="cu-container">
          <div className="cu-map-wrap">
            <iframe
              title="Bizaario Care Location"
              className="cu-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.0!2d77.3910!3d28.6270!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sSector%2063%2C%20Noida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000000"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Container>
      </section>

      {/* ── FAQs ── */}
      <section className="cu-faq-section">
        <Container fluid className="cu-container">
          <h2 className="cu-faq__title">FAQs (Frequently Asked Questions)</h2>
          <p className="cu-faq__subtitle">
            Here are some sample FAQs for a Doctor Portal, suitable for a
            website or app used by doctors for managing appointments, patients,
            records, collaborations, etc.
          </p>
          <div className="cu-faq__list">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`cu-faq__item ${openFaq === i ? "cu-faq__item--open" : ""}`}
              >
                <button
                  className="cu-faq__question"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  aria-expanded={openFaq === i}
                >
                  <span>{faq.q}</span>
                  <span className="cu-faq__icon">
                    {openFaq === i ? "−" : "+"}
                  </span>
                </button>
                {openFaq === i && (
                  <div className="cu-faq__answer">
                    This feature is available on the portal. Please contact
                    support for more details or refer to the documentation for
                    step-by-step guidance.
                  </div>
                )}
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};
